// @ts-nocheck
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";

export default function Tabs({ setIndex, index }) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  return (
    <div className="w-full px-4 py-2">
      <div className="flex items-center justify-start relative">
        <div 
          className={`px-6 py-2 font-medium text-base cursor-pointer transition-colors duration-200 relative ${
            index === 1 
              ? "text-primary border-b-2 border-primary" 
              : "text-neutral-400 hover:text-neutral-300"
          }`}
          onClick={() => {
            setIndex(1);
          }}
        >
          {translate(getText("委託中"))}
        </div>
        <div 
          className={`px-6 py-2 font-medium text-base cursor-pointer transition-colors duration-200 relative ${
            index === 2 
              ? "text-primary border-b-2 border-primary" 
              : "text-neutral-400 hover:text-neutral-300"
          }`}
          onClick={() => {
            setIndex(2);
          }}
        >
          {translate(getText("已完成"))}
        </div>
      </div>
    </div>
  );
}
